import styled, { css } from "styled-components";
import { ddmTheme } from "@ddm-design-system/tokens";

const AnimatedDDM = styled(ddmTheme.icons.DmLogo)`
  height: 24px;
  animation: ${css`
    ${ddmTheme.animations.rotate} 1s infinite
  `};
`;

export default AnimatedDDM;
